import React from 'react';
import { Button } from '../components/ui/button';
import { ArrowRight, Shield, Award, Clock } from 'lucide-react';

const CTASection = ({ onContactClick }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-amber-500/20 backdrop-blur-sm border border-amber-500/30 rounded-full px-4 py-2 mb-6">
            <Clock size={18} className="text-amber-400" />
            <span className="text-amber-100 text-sm font-medium">
              Limited Time Offer - Start Your Application Today
            </span>
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Ready to Protect Your Brand?
          </h2>
          
          <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Secure your trademark rights today and protect your business from copycats and infringement.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button
              onClick={onContactClick}
              size="lg"
              className="bg-amber-500 hover:bg-amber-600 text-white px-8 py-6 text-lg font-semibold group"
            >
              Protect My Brand Now
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            
            <Button
              onClick={onContactClick}
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-blue-900 px-8 py-6 text-lg font-semibold"
            >
              Schedule Free Consultation
            </Button>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mb-4">
                <Shield size={32} className="text-white" />
              </div>
              <h3 className="text-xl font-bold mb-2">100% Secure</h3>
              <p className="text-blue-100 text-sm">
                Your information is protected with industry-standard encryption
              </p>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mb-4">
                <Award size={32} className="text-white" />
              </div>
              <h3 className="text-xl font-bold mb-2">Expert Service</h3>
              <p className="text-blue-100 text-sm">
                Experienced trademark professionals handle your application
              </p>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mb-4">
                <Clock size={32} className="text-white" />
              </div>
              <h3 className="text-xl font-bold mb-2">Fast Filing</h3>
              <p className="text-blue-100 text-sm">
                Quick turnaround on application preparation and filing
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/20">
            <p className="text-blue-100 text-lg">
              <strong className="text-white">Every day you wait</strong> is another day your brand remains unprotected.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
